import React from "react";
import { Heading } from "../../design/heading";
import { Text } from "../../design/text";
import { Table, TableBody } from "../../design/table";
import ErrorView from "../../components/ErrorView";
import LoadingView from "../../components/LoadingView";
import { useMatter } from "../../contexts/MatterContext";
import NoMatterView from "../../components/NoMatterView";
import FinancialAccountListItem from "./components/FinancialAccountListItem";
import { useFinancialAccount } from "../../contexts/FinancialAccountContext";

const FinancialAccountListPage: React.FC = () => {
  const { currentMatterId } = useMatter();
  const { financialAccounts, loading, error } = useFinancialAccount();

  if (!currentMatterId) return <NoMatterView />;
  if (loading.list)
    return <LoadingView title="Loading Financial Transactions..." />;
  if (error.list) return <ErrorView error={error.list} />;

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          <Heading>Linked Accounts</Heading>
          <Text>
            Below are the accounts that have been linked. Click the Transactions
            tab to view and customize the imported data. Please note that
            Investment/Retirement account data is limited to current balances.
            Important: Once you have synced the accounts, click the individual
            Asset/Debt cards and choose Account link for the balances to
            automatically update the Net Worth Report.
          </Text>
        </div>
      </div>

      <Table className="[--gutter:theme(spacing.6)] lg:[--gutter:theme(spacing.10)]">
        <TableBody>
          {financialAccounts.map((tx: any) => (
            <FinancialAccountListItem key={tx._id} financialAccount={tx} />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default FinancialAccountListPage;
